import { render } from "./CompletionList.vue?vue&type=template&id=4eb57af1&scoped=true"
import script from "./CompletionList.vue?vue&type=script&lang=js"
export * from "./CompletionList.vue?vue&type=script&lang=js"

import "./CompletionList.vue?vue&type=style&index=0&id=4eb57af1&scoped=true&lang=scss"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eb57af1"]])

export default __exports__